import React, { useState, useEffect } from 'react';
import './ConoceColombiaPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const FALLBACK_IMAGE = '/images/hero-viajes-colombia.png';

const DESTINATIONS = [
  {
    id: 'pacifico',
    title: 'Avistamiento de ballenas en el Pacífico',
    location: 'La Barra (Juanchaco) y Ladrilleros. Salida en lancha desde Buenaventura.',
    description: 'Vive una experiencia única avistando ballenas jorobadas en el Pacífico colombiano. Incluye actividad con la comunidad local, gastronomía y 3 comidas al día.',
    image: '/images/viajes-pacifico-ballenas.png',
    highlights: ['Ballenas jorobadas', 'Actividad con comunidad', 'Gastronomía', 'Ecoturismo'],
    packages: [
      {
        label: '4 días, 3 noches',
        itinerary: [
          'DÍA 1: Llegada a Buenaventura, traslado en lancha a Juanchaco. Actividad con comunidad local.',
          'DÍA 2: Avistamiento de ballenas jorobadas en el Pacífico. Gastronomía tradicional.',
          'DÍA 3: Playas de La Barra y Ladrilleros. Actividad con pescadores.',
          'DÍA 4: Regreso a ciudad de origen.'
        ]
      },
      {
        label: '5 días, 4 noches',
        itinerary: [
          'DÍA 1: Llegada a Buenaventura, traslado en lancha a Juanchaco. Actividad con comunidad local.',
          'DÍA 2: Avistamiento de ballenas jorobadas en el Pacífico. Gastronomía tradicional.',
          'DÍA 3: Playas de La Barra y Ladrilleros. Actividad con pescadores.',
          'DÍA 4: Isla de Ladrilleros, manglares y experiencia comunitaria.',
          'DÍA 5: Regreso a ciudad de origen.'
        ]
      }
    ]
  },
  {
    id: 'san-andres',
    title: 'San Andrés y Providencia',
    location: 'San Andrés, Colombia',
    description: 'Descubre el Caribe colombiano: playas de aguas cristalinas, cultura raizal y naturaleza. Incluye actividad con la comunidad raizal.',
    image: '/images/viajes-san-andres-providencia.png',
    highlights: ['Aguas cristalinas', 'Actividad con comunidad raizal', 'Caribe colombiano'],
    packages: [
      {
        label: '4 días, 3 noches',
        itinerary: [
          'DÍA 1: Llegada a San Andrés. Actividad con comunidad raizal.',
          'DÍA 2: Tour Johnny Cay, Cayo Acuario. Snorkel y playas.',
          'DÍA 3: Providencia o Isla de San Luis. Cultura raizal.',
          'DÍA 4: Regreso a ciudad de origen.'
        ]
      },
      {
        label: '5 días, 4 noches',
        itinerary: [
          'DÍA 1: Llegada a San Andrés. Actividad con comunidad raizal.',
          'DÍA 2: Tour Johnny Cay, Cayo Acuario. Snorkel.',
          'DÍA 3: Providencia. Mar de los siete colores, cultura raizal.',
          'DÍA 4: Hoyo Soplador, playa Spratt Bight. Experiencia comunitaria.',
          'DÍA 5: Regreso a ciudad de origen.'
        ]
      }
    ]
  },
  {
    id: 'amazonas',
    title: 'Amazonas colombiano',
    location: 'Amazonas, Colombia',
    description: 'Inmersión en la selva amazónica: biodiversidad y experiencias únicas. Incluye actividad con comunidades indígenas.',
    image: '/images/viajes-amazonas.png',
    highlights: ['Selva amazónica', 'Actividad con comunidad indígena', 'Biodiversidad'],
    packages: [
      {
        label: '4 días, 3 noches',
        itinerary: [
          'DÍA 1: Llegada a Leticia. Actividad con comunidad indígena.',
          'DÍA 2: Selva amazónica, río Amazonas. Delfines rosados.',
          'DÍA 3: Reserva natural, biodiversidad. Experiencia con comunidad.',
          'DÍA 4: Regreso a ciudad de origen.'
        ]
      },
      {
        label: '5 días, 4 noches',
        itinerary: [
          'DÍA 1: Llegada a Leticia. Actividad con comunidad indígena.',
          'DÍA 2: Selva amazónica, río Amazonas. Delfines rosados.',
          'DÍA 3: Reserva natural, victorias amazónicas. Comunidad local.',
          'DÍA 4: Isla de los Micos, lago Tarapoto. Experiencia comunitaria.',
          'DÍA 5: Regreso a ciudad de origen.'
        ]
      }
    ]
  },
  {
    id: 'tayrona',
    title: 'Santa Marta y playas del Tayrona',
    location: 'Santa Marta, Parque Tayrona y playas cercanas',
    description: 'Costa caribeña: Santa Marta, Parque Nacional Natural Tayrona y playas paradisíacas. Incluye actividad con la comunidad local.',
    image: '/images/viajes-santa-marta-tayrona.png',
    highlights: ['Parque Tayrona', 'Actividad con comunidad', 'Costa caribeña'],
    packages: [
      {
        label: '4 días, 3 noches',
        itinerary: [
          'DÍA 1: Llegada a Santa Marta. Actividad con comunidad local.',
          'DÍA 2: Parque Tayrona, Cabo San Juan. Playas y naturaleza.',
          'DÍA 3: Taganga o Minca. Experiencia comunitaria.',
          'DÍA 4: Regreso a ciudad de origen.'
        ]
      },
      {
        label: '5 días, 4 noches',
        itinerary: [
          'DÍA 1: Llegada a Santa Marta. Actividad con comunidad local.',
          'DÍA 2: Parque Tayrona, Cabo San Juan. Playas.',
          'DÍA 3: Taganga, Minca. Sierra Nevada. Experiencia comunitaria.',
          'DÍA 4: Playa Cristal, Bahía Concha. Snorkel.',
          'DÍA 5: Regreso a ciudad de origen.'
        ]
      }
    ]
  }
];

const PERSONALIZED_TRIP = {
  id: 'personalizado',
  title: 'Viaje personalizado',
  location: 'Colombia',
  description: '¿Quieres un acompañamiento más personalizado? Te ayudamos a cuadrar tu viaje por Colombia según tus fechas, preferencias y presupuesto. Ideal para viajeros internacionales.',
  image: '/images/hero-viajes-colombia.png',
  highlights: ['A tu medida', 'Fechas flexibles', 'Cotización personalizada'],
  isPersonalized: true
};

const ConoceColombiaPage = () => {
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [registrationTrip, setRegistrationTrip] = useState(null);
  const [showRegistration, setShowRegistration] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const allExperiences = [...DESTINATIONS, PERSONALIZED_TRIP];

  const handleRegistration = (trip) => {
    setRegistrationTrip(trip);
    setSelectedDestination(null);
    setShowRegistration(true);
  };

  const handleCardClick = (item) => {
    if (item.isPersonalized) {
      handleRegistration(item);
    } else {
      setSelectedDestination(item);
    }
  };

  return (
    <div className="conoce-colombia-page">
      <Header />
      <AnimatedBackground particleCount={15} staticCount={4} />

      <section
        className="conoce-colombia-hero"
        style={{
          background: `linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.65) 100%), url(${process.env.PUBLIC_URL || ''}/images/hero-conoce-colombia-4destinos.png) center/cover no-repeat, url(${process.env.PUBLIC_URL || ''}/images/hero-viajes-colombia.png) center/cover no-repeat`,
          backgroundColor: '#0a0a0a'
        }}
      >
        <div className="cc-hero-copy-centered">
          <span className="cc-tag">JAVILAND</span>
          <h1 className="cc-headline">Conoce las tierras colombianas</h1>
          <p className="cc-narrative">
            Somos una comunidad que ofrece diferentes experiencias por el territorio nacional.
            Todos nuestros viajes son de <strong>ecoturismo comunitario</strong>: cada experiencia incluye al menos una actividad con la comunidad local.
          </p>
          <p className="cc-subline">
            Viaja por paquetes. Ecoturismo comunitario. Ideal para viajeros internacionales.
          </p>
          <button className="cc-cta" onClick={() => document.getElementById('experiencias-grid')?.scrollIntoView({ behavior: 'smooth' })}>
            Ver experiencias
          </button>
        </div>
      </section>

      <main className="conoce-colombia-main">
        <div className="container">
          <h2 id="experiencias-grid">5 experiencias de ecoturismo comunitario</h2>
          <p className="cc-packages-intro">Cada destino ofrece paquetes de 4 días/3 noches y 5 días/4 noches. Completa el formulario y te enviamos una cotización detallada.</p>
          <div className="trips-grid">
            {allExperiences.map((item) => (
              <article
                key={item.id}
                className={`trip-card ${item.isPersonalized ? 'trip-card-personalized' : ''}`}
                onClick={() => handleCardClick(item)}
              >
                <div className="trip-image">
                  <img src={item.image} alt={item.title} onError={(e) => { e.target.src = FALLBACK_IMAGE; }} />
                  {item.packages && (
                    <span className="trip-package-badge">2 planes</span>
                  )}
                  {item.isPersonalized && (
                    <span className="trip-package-badge">A tu medida</span>
                  )}
                </div>
                <div className="trip-content">
                  <h3 className="trip-title">{item.title}</h3>
                  <p className="trip-location">
                    <i className="fas fa-map-marker-alt"></i>
                    {item.location}
                  </p>
                  <ul className="trip-highlights">
                    {item.highlights.map((h, i) => (
                      <li key={i}>{h}</li>
                    ))}
                  </ul>
                  <button className="trip-cta">
                    {item.isPersonalized ? 'Solicitar cotización' : 'Más información'}
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </main>

      {/* Modal: itinerario detallado con los 2 planes */}
      {selectedDestination && selectedDestination.packages && (
        <div className="trip-modal-overlay" onClick={() => setSelectedDestination(null)}>
          <div className="trip-modal trip-modal-plans" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedDestination(null)}>
              <i className="fas fa-times"></i>
            </button>
            <div className="trip-modal-content">
              <h2 className="trip-modal-title">{selectedDestination.title}</h2>
              <div className="trip-modal-meta">
                <span><i className="fas fa-map-marker-alt"></i> {selectedDestination.location}</span>
              </div>
              <p className="trip-modal-description">{selectedDestination.description}</p>
              <p className="trip-modal-plans-intro">Ofrecemos dos planes para este destino:</p>
              {selectedDestination.packages.map((pkg, idx) => (
                <div key={idx} className="trip-modal-itinerary">
                  <h4>{pkg.label}</h4>
                  <ul>
                    {pkg.itinerary.map((day, i) => (
                      <li key={i}>{day}</li>
                    ))}
                  </ul>
                </div>
              ))}
              <ul className="trip-modal-highlights">
                {selectedDestination.highlights.map((h, i) => (
                  <li key={i}><i className="fas fa-check"></i> {h}</li>
                ))}
              </ul>
              <button className="register-btn" onClick={() => handleRegistration(selectedDestination)}>
                <i className="fas fa-file-invoice"></i>
                Solicitar cotización
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: formulario de cotización */}
      {showRegistration && (
        <div className="registration-modal-overlay" onClick={() => { setShowRegistration(false); setRegistrationTrip(null); }}>
          <div className="registration-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => { setShowRegistration(false); setRegistrationTrip(null); }}>
              <i className="fas fa-times"></i>
            </button>
            <div className="registration-content">
              <h3>{registrationTrip ? `Cotización: ${registrationTrip.title}${registrationTrip.packages ? ' (elige plan en comentarios)' : ''}` : 'Acompañamiento personalizado'}</h3>
              <p>{registrationTrip ? 'Completa el formulario y te enviamos una cotización detallada con precios, fechas disponibles y toda la información.' : 'Cuéntanos qué buscas y te ayudamos a armar tu viaje por Colombia.'}</p>
              <form className="registration-form">
                <div className="form-group">
                  <label>Nombre completo</label>
                  <input type="text" required placeholder="Ej. John Smith" />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" required placeholder="tu@email.com" />
                </div>
                <div className="form-group">
                  <label>Teléfono (con código de país)</label>
                  <input type="tel" required placeholder="Ej. +1 555 123 4567" />
                </div>
                <div className="form-group">
                  <label>País de origen</label>
                  <input type="text" placeholder="Ej. Estados Unidos" />
                </div>
                <div className="form-group">
                  <label>Comentarios o preferencias</label>
                  <textarea rows="3" placeholder="Fechas tentativas, número de viajeros, preferencias especiales..."></textarea>
                </div>
                <button type="submit" className="pay-btn">
                  <i className="fas fa-paper-plane"></i>
                  Enviar solicitud de cotización
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ConoceColombiaPage;
